module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AS-ac2dc8a7ac77a73c2269afd019b4d6f2.png";